import http from "./httpService";

const baseUrl = `/rewards`;

// month: "YYYY-MM" (optional — backend defaults to the current month).
export const getRewardEligibility = async (month) => {
  try {
    const { data } = await http.get(baseUrl, { params: month ? { month } : {} });
    return data;
  } catch (err) {
    return null;
  }
};
